import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { ImportSecurityCategorySecuritiesDialogComponent } from './import-security-category-securities-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportSecurityCategoryInventoriedGridLayoutService implements GridLayoutService<ImportSecurityCategorySecuritiesDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {            
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent
        };
    }

    getColumnDefs(_parent: ImportSecurityCategorySecuritiesDialogComponent) {
        return [
        {
            headerName: 'Symbol/CUSIP',            
            field: 'securitySymbol',
            maxWidth: 130,
            width: 130
        },
        {
            headerName: 'Description',
            field: 'securityDescription',
            maxWidth: 371,
            cellRenderer: "TruncateTooltipCellComponent"
        },
        {
            headerName: 'Type',
            field: 'securityType',
            maxWidth: 140,
            width: 140
        },
        {
            headerName: 'Custom Category',
            field: 'newCustomCategory',
            colId: "custCategoryCol",
            cellRendererSelector: (params: any) => {
                let finalValue = '';
                if (params.data) {
                  if (params.data.newCustomCategory != null && params.data.newCustomCategory.length > 0) {
                    finalValue = params.data.newCustomCategory;
                  } else {
                    finalValue = params.data.oldCustomCategory;
                  }
                }
                return {
                  component: 'cellRendererFormatter',
                  params: { value: finalValue }
                };
              },
            maxWidth: 170,
            width: 170,            
        }];
    }
}
